module.exports = __webpack_public_path__ + "static/BRAIN-826bdac36399bbed33207bf8a71af33e.png";